module.exports = __webpack_public_path__ + "img/manage-certification.6958f7fe.png";